const games = [
    {
        title: 'F-Zero GX (2003)',
        fileName: 'fzerogx.md',
        citations: 'fzerogxc.md',
    }
];

export default games;